/**
 * Keeps the same object for a hit whose data has not changed between renders of a listing.
 *
 * InstantSearch renders the hits again right after hydration (new objects, same data). Product tiles are hydrated
 * lazily (hydrate-on-visible), and a prop update forces a not yet hydrated component to hydrate at once: every tile
 * on the page was hydrated, visible or not. With the same object Vue skips the tile (mobiilinopeus 4.11.2026).
 */
export function useStableHits<T extends { slug?: string }>() {
  let previous = new Map<string, { json: string, hit: T }>()

  return (hits: T[]): T[] => {
    const next = new Map<string, { json: string, hit: T }>()
    const stable = hits.map((hit) => {
      const json = JSON.stringify(hit)
      const key = hit.slug ?? json
      const known = previous.get(key)
      const result = known && known.json === json ? known.hit : hit
      next.set(key, { json, hit: result })
      return result
    })
    previous = next
    return stable
  }
}
